import BonusDto from '@app/promotionHub/bonuses/types/betlerDto/BetlerBonusDto';

/* eslint-disable camelcase */
export type BetlerPromotionDto = {
    id: string;
    customer_id: string;
    status: BetlerPromotionStatusDto;
    campaign: BetlerCampaignDto;
    qualification_progress?: BetlerQualificationDto;
    opt_in_out_date: string;
};

type BetlerCampaignDto = {
    campaign_id: string;
    campaign_instance_id: string;
    campaign_images?: BetlerCampaignImage[];
    name: string;
    internal_name: string;
    dates: BetlerCampaignDatesDto;
    bonus: BonusDto;
    qualification_criteria: QualificationCriteriaDto[];
    qualification_type?: CampaignQualificationType;
    terms_and_conditions_url?: string;
    call_to_action_text?: string;
    call_to_action_deeplink?: string;
    dynamic_bonus_input: DynamicBonusInputDto;
};

export type QualificationCriteriaDto = {
    criteria: string,
    type: QualificationCriteriaType;
};

type BetlerCampaignDatesDto = {
    start: string;
    finish?: string;
    end?: string;
};

export const QualificationCriteriaType = {
    Deposit: 'deposit',
    Sportsbook: 'sportsbook',
    Gaming: 'gaming',
};
export type QualificationCriteriaType = typeof QualificationCriteriaType[keyof typeof QualificationCriteriaType];

export const CampaignQualificationType = {
    Manual: 'manual',
} as const;
export type CampaignQualificationType = typeof CampaignQualificationType[keyof typeof CampaignQualificationType];

export const BetlerPromotionStatusDto = {
    Eligible: 'eligible',
    OptedIn: 'opted_in',
    InProgress: 'in_progress',
    Qualified: 'qualified',
    Expired: 'expired',
};
export type BetlerPromotionStatusDto = typeof BetlerPromotionStatusDto[keyof typeof BetlerPromotionStatusDto];

export const stakeMultiplierString = 'amount_deposited_staked_multiplier';

export type BetlerMultiConditionQualificationProgressDto = {
    current_phase: number;
    phases: BetlerQualificationProgressDto[];
};

export type BetlerQualificationProgressDto = {
    no_of_deposits_made?: number;
    no_of_deposits_required?: number;
    currency_amount_of_deposits_made?: number;
    currency_amount_of_deposits_required?: number;
    no_of_bets_made?: number;
    no_of_bets_required?: number;
    no_of_settled_bets_made?: number;
    no_of_unsettled_bets_made?: number;
    currency_amount_of_bets_made?: number;
    currency_amount_of_bets_required?: number | typeof stakeMultiplierString;
    currency_amount_of_settled_bets_made?: number;
    currency_amount_of_unsettled_bets_made?: number;
    no_of_spins_made?: number;
    no_of_spins_required?: number;
    currency_amount_of_spins_made?: number;
    currency_amount_of_spins_required?: number;
    phase?: number;
    total_staked_multiplier?: number;
};

export type BetlerQualificationDto = BetlerMultiConditionQualificationProgressDto | BetlerQualificationProgressDto;

export type BetlerCampaignImage = {
    date_uploaded: string;
    filename: string;
    id: string;
    image_url: string;
};

export const DynamicBonusInputDto = {
    WinningBetAmount: 'winningBetAmount',
    WinningSpinAmount: 'winningSpinAmount',
    CashbackNetLossesOnBets: 'cashbackNetLossesOnBets',
    CashbackNetLossesOnSpins: 'cashbackNetLossesOnSpins',
    Deposits: 'deposits',
} as const;
export type DynamicBonusInputDto = typeof DynamicBonusInputDto[keyof typeof DynamicBonusInputDto];
